import React, {useEffect} from 'react';
import {
    addTableColumn,
    initializeAddColumnModal,
    setShowAddColumnModal,
    unmountAddColumnModal
} from "../../redux-store/dynamicTable";
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {getDynamicTableById, showAddColumnModal, uniqueDeviceTypes} from "../../redux-store/selectors";
import {Form, Input, Select} from "antd";
import {columnAlignmentOptions, columnTypeOptions, pipeArgOptions} from "./TableConfigStaticSelectOptions";
import {REQUIRED_FIELD} from "../../constants/Messages";
import ErrorIcon from "../../images/errorIcon.png";

const {Option} = Select

function TableConfigAddColumnModal({id}) {

    const table = useSelector(getDynamicTableById(id))
    const {uniqueReadableParams, uniqueCommandProducers} = useSelector(uniqueDeviceTypes)
    const show = useSelector(showAddColumnModal).find(modal => modal.id === id)?.show || false

    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(initializeAddColumnModal(id))
        return () => {
            dispatch(unmountAddColumnModal(id))
        }
    }, [])

    const generateID = (min) => {

        let id = Math.floor(Math.random() * 1000) + min

        let indexOfExistingID = table.columns.findIndex((col)=>col.id===id)

        while (indexOfExistingID>=0){
            id = Math.floor(Math.random() * 1000) + min
            indexOfExistingID = table.columns.findIndex((col)=>col.id===id)
        }

        return id
    }

    const onFinish = (data) => {

        data.id = generateID(table.columns[table.columns.length - 1].id)

        if (data.type === "DATA") {
            data.methodName = null
            data.arguments = null
        } else if (data.type === "COMMAND") {
            data.parameterName = null;
            data.pipe = null;
            data.pipeArg = null;
            data.alignment = "CENTER";
            if (data.arguments) data.arguments = JSON.parse("[" + data.arguments + "]");
            else data.arguments = [];
        }

        dispatch(addTableColumn({data: data, tableId: id}))
        dispatch(setShowAddColumnModal({show: false, id}))
    }

    const handleCloseModal = (e) => {
        e.preventDefault()
        dispatch(setShowAddColumnModal({show: false, id}))
    }


    return (
        <Modal
            show={show}
            onHide={() => {
                dispatch(setShowAddColumnModal({show: false, id}))
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title className={"title-confirm"}>Dodavanje kolone</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <Form name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off"
                          className={"flux-tables-antd"}>
                        <Form.Item
                            name={'type'}
                            rules={[
                                {
                                    required: true,
                                    message: <span className="loggin-error"><img alt="Error"
                                                                                 src={ErrorIcon}/> {REQUIRED_FIELD}</span>,
                                },
                            ]}
                        >
                            <Select
                                placeholder={"Type"}
                                className={"form-select"}
                                getPopupContainer={node => node.parentNode}
                            >
                                {columnTypeOptions.map((item, index) => {
                                    return (<Option key={index} value={item.value}>{item.label}</Option>)
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            noStyle
                            shouldUpdate={true}
                        >
                            {({getFieldValue}) => {
                                if (!getFieldValue("type")) {
                                    return;
                                }
                                return getFieldValue("type") === 'DATA' ? (<Form.Item
                                    name={'parameterName'}
                                    rules={[
                                        {
                                            required: true,
                                            message: <span className="loggin-error"><img alt="Error"
                                                                                         src={ErrorIcon}/> {REQUIRED_FIELD}</span>,
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={"Parameter Name"}
                                        className={"form-select"}
                                        showSearch
                                        getPopupContainer={node => node.parentNode}
                                    >
                                        {uniqueReadableParams.map((item, index) => {
                                            return (<Option key={index} value={item}>{item}</Option>)
                                        })}
                                    </Select>
                                </Form.Item>) : (<>
                                        <Form.Item
                                            name={"methodName"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: <span className="loggin-error"><img alt="Error"
                                                                                                 src={ErrorIcon}/> {REQUIRED_FIELD}</span>,
                                                },
                                            ]}
                                        >
                                            <Select
                                                placeholder={"Method Name"}
                                                className={"form-select"}
                                                showSearch
                                                getPopupContainer={node => node.parentNode}
                                            >
                                                {uniqueCommandProducers.map((item, index) => {
                                                    return (<Option key={index} value={item}>{item}</Option>)
                                                })}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            name={'arguments'}
                                        >
                                            <Input placeholder="Arguments"/>
                                        </Form.Item>
                                    </>

                                )
                            }}
                        </Form.Item>
                        <Form.Item
                            name={'title'}
                        >
                            <Input placeholder="Title" className={"form-control"}/>
                        </Form.Item>
                        <Form.Item
                            name={'description'}
                        >
                            <Input placeholder="Description" className={"form-control"}/>
                        </Form.Item>
                        <Form.Item
                            noStyle
                            shouldUpdate={true}
                        >
                            {({getFieldValue}) => {
                                if (!getFieldValue("type")) {
                                    return;
                                }
                                return getFieldValue("type") === 'DATA' && (<>
                                    <Form.Item
                                        name={'pipe'}
                                    >
                                        <Select
                                            placeholder={"pipe"}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {pipeArgOptions.map((item, index) => {
                                                return (<Option key={index} value={item.value}>{item.label}</Option>)
                                            })}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        name={'pipeArg'}
                                    >
                                        <Input placeholder="PipeArg" className={"form-control"}/>
                                    </Form.Item>
                                    <Form.Item
                                        name={'alignment'}
                                    >
                                        <Select
                                            placeholder={"Alignment"}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {columnAlignmentOptions.map((item, index) => {
                                                return (<Option key={index} value={item.value}>{item.label}</Option>)
                                            })}
                                        </Select>
                                    </Form.Item>

                                </>)
                            }}
                        </Form.Item>
                        <div className={"ant-form-tables-flux"}>
                            <button className={"btn btn-modal-confirm"}>Dodaj</button>
                            <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                                Odustani
                            </button>
                        </div>

                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default TableConfigAddColumnModal;